import { hasCoachSettingsUnsavedChanges } from "./coachSettingsChanges";
import {
  discardClientProfileDraft,
  hasClientProfileUnsavedChanges,
} from "./clientProfileUnsavedChanges";

const UNSAVED_LEAVE_CONTEXTS = {
  CLIENT_PROFILE: "client-profile",
  COACH_SETTINGS: "coach-settings",
};

const shouldGuardClientProfileLeave = ({ coach, selectedClient }) =>
  coach?.showingCoachView === "ClientDashboard" &&
  !!selectedClient &&
  selectedClient.selectedTab === "profile-string" &&
  !selectedClient.isOffline &&
  hasClientProfileUnsavedChanges(selectedClient);

const shouldGuardCoachSettingsLeave = (coach) =>
  coach?.showingCoachView === "CoachSettings" &&
  !coach?.isOffline &&
  hasCoachSettingsUnsavedChanges(coach);

export const getUnsavedLeaveGuardContext = ({ coach, selectedClient }) => {
  if (shouldGuardClientProfileLeave({ coach, selectedClient })) {
    return UNSAVED_LEAVE_CONTEXTS.CLIENT_PROFILE;
  }

  if (shouldGuardCoachSettingsLeave(coach)) {
    return UNSAVED_LEAVE_CONTEXTS.COACH_SETTINGS;
  }

  return null;
};

export const discardUnsavedLeaveDraft = ({
  guardContext,
  selectedClient,
  coachSettingsLeaveHandlers,
}) => {
  if (
    guardContext === UNSAVED_LEAVE_CONTEXTS.CLIENT_PROFILE &&
    selectedClient &&
    !selectedClient.isOffline
  ) {
    discardClientProfileDraft(selectedClient);
    return true;
  }

  if (guardContext === UNSAVED_LEAVE_CONTEXTS.COACH_SETTINGS) {
    if (typeof coachSettingsLeaveHandlers?.discard === "function") {
      coachSettingsLeaveHandlers.discard();
      return true;
    }

    return false;
  }

  return false;
};

export { UNSAVED_LEAVE_CONTEXTS };
